import { render, staticRenderFns } from "./TcLogin.vue?vue&type=template&id=d245b98c&"
import script from "./TcLogin.vue?vue&type=script&lang=js&"
export * from "./TcLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d245b98c')) {
      api.createRecord('d245b98c', component.options)
    } else {
      api.reload('d245b98c', component.options)
    }
    module.hot.accept("./TcLogin.vue?vue&type=template&id=d245b98c&", function () {
      api.rerender('d245b98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcLogin.vue"
export default component.exports